/* App Guide — TOC build, scroll-spy, search + group filter */
(function(){
  var main=document.querySelector('[data-ag-main]');if(!main)return;
  var shell=document.querySelector('[data-ag-shell]'),nav=document.querySelector('[data-ag-nav]'),sel=document.querySelector('[data-ag-sel]'),count=document.querySelector('[data-ag-count]'),q=document.getElementById('ag-q'),top=document.querySelector('[data-ag-top]');
  var secs=[].slice.call(main.querySelectorAll('.ag-sec'));
  var GROUPS={start:'Getting started',track:'Everyday tracking',alerts:'Alerts & zones',health:'Vehicle health & records',report:'Reporting',people:'People & access',share:'Sharing',device:'Device configuration',personal:'Personalization',rest:'The rest'};

  // Build sidebar + mobile select from the sections themselves.
  var lastG='',frag=document.createDocumentFragment();
  secs.forEach(function(s,i){
    var g=s.dataset.g,hd=s.querySelector('.ag-sec__h').cloneNode(true),n=String(i+1).padStart(2,'0');
    // Badges like "OBD+ only" are heading decoration — keep them out of the TOC label.
    [].slice.call(hd.querySelectorAll('.ag-badge')).forEach(function(b){b.remove()});
    var title=hd.textContent.trim();
    if(g!==lastG){var h=document.createElement('div');h.className='ag-side__g';h.textContent=GROUPS[g]||g;frag.appendChild(h);lastG=g}
    var a=document.createElement('a');a.href='#'+s.id;a.dataset.for=s.id;a.innerHTML='<i>'+n+'</i><span>'+title+'</span>';frag.appendChild(a);
    var o=document.createElement('option');o.value=s.id;o.textContent=n+' · '+title;sel.appendChild(o);
  });
  nav.appendChild(frag);
  var links=[].slice.call(nav.querySelectorAll('a'));
  sel.addEventListener('change',function(){var el=document.getElementById(sel.value);if(el)window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-84,behavior:'smooth'})});

  // Scroll-spy
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting)return;
      links.forEach(function(a){a.classList.toggle('is-active',a.dataset.for===e.target.id)});
      if(sel.value!==e.target.id)sel.value=e.target.id;
      var on=nav.querySelector('a.is-active');
      if(on&&nav.scrollHeight>nav.clientHeight){var r=on.getBoundingClientRect(),p=nav.parentElement.getBoundingClientRect();if(r.top<p.top+8||r.bottom>p.bottom-8)nav.parentElement.scrollTop+=r.top-p.top-120}
    });
  },{rootMargin:'-88px 0px -70% 0px',threshold:0});
  secs.forEach(function(s){io.observe(s)});

  // Filter: group chips + text search
  var group='all',term='';
  function apply(){
    var shown=0;
    secs.forEach(function(s){
      var okG=group==='all'||s.dataset.g===group;
      var okT=!term||(s.dataset.k+' '+s.textContent).toLowerCase().indexOf(term)>-1;
      var on=okG&&okT;
      s.style.display=on?'':'none';
      var a=nav.querySelector('a[data-for="'+s.id+'"]');if(a)a.style.display=on?'':'none';
      if(on)shown++;
    });
    // Hide group headings with no visible links left.
    [].slice.call(nav.children).forEach(function(el){
      if(!el.classList.contains('ag-side__g'))return;
      var any=false,n=el.nextElementSibling;
      while(n&&!n.classList.contains('ag-side__g')){if(n.style.display!=='none')any=true;n=n.nextElementSibling}
      el.style.display=any?'':'none';
    });
    shell.classList.toggle('is-empty',shown===0);
    if(count)count.textContent=shown===secs.length?secs.length+' sections':shown+' of '+secs.length;
  }
  document.querySelectorAll('.ag-gchip').forEach(function(b){
    b.addEventListener('click',function(){
      group=b.dataset.g;
      document.querySelectorAll('.ag-gchip').forEach(function(o){var on=o===b;o.classList.toggle('is-on',on);o.setAttribute('aria-selected',on)});
      apply();
    });
  });
  var t;
  q.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){term=q.value.trim().toLowerCase();apply()},110)});

  // Back to top
  window.addEventListener('scroll',function(){top.classList.toggle('is-on',window.pageYOffset>900)},{passive:true});
  top.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
  apply();
})();
